import { createSelectorCreator, defaultMemoize } from 'reselect';
import _ from 'lodash';
import { isArrayEqual } from '../utilities/data';

export const createDeepSelector = createSelectorCreator(defaultMemoize, _.isEqual);
export const createDeepArraySelector = createSelectorCreator(defaultMemoize, isArrayEqual);
